import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import {
  openLinkInNewTab,
  shouldOpenInNewTab,
} from "discourse/lib/click-track";

export default class DHtmlWithLinks extends Component {
  @action
  click(event) {
    if (event.target.tagName === "A") {
      if (shouldOpenInNewTab(event.target.href)) {
        openLinkInNewTab(event, event.target);
      }
    }
  }

  <template>
    {{! eslint-disable ember/template-no-invalid-interactive }}
    <div ...attributes {{on "click" this.click}}>{{yield}}</div>
  </template>
}
